<template>
  <ul 
    v-if="colors.length"
    class="list-inline swatch-list">
    <li
      v-for="swatch in colors"
      :key="swatch.colorcode"
      v-if="!saleOnly || swatch.on_sale">
      <a 
        :href="swatchUrl(swatch)"
        :data-alt-image="swatch.colorImageUrl"
        :data-on-sale="swatch.on_sale"
        @click="onProductClick"
        @mouseenter="onSwatchMouseEnter">
        <img
          v-if="lazy" 
          :data-hover-src="swatch.swatchImageUrl" 
          :alt="swatch.colorname">
        <img
          v-else
          :src="swatch.swatchImageUrl" 
          :alt="swatch.colorname">
      </a>
    </li>
  </ul>
</template>

<style scoped>
</style>

<script>
import { handleProductClick } from '../../module/util'

export default {
    props: {
        colors: {
            type: Array,
            default () { return [] }
        },
        productUrl: {
            type: String,
            default: null
        },
        saleOnly: {
            type: Boolean,
            default: false
        },
        lazy: {
            type: Boolean,
            default: true
        }
    },

    methods: {
        onProductClick () {
            handleProductClick()
        },
        swatchUrl (swatch) {
            let url = this.productUrl + '#color=' + swatch.colorcode
            if (swatch.on_sale) {
                url += '&sale=1'
            }
            return url
        },
        onSwatchMouseEnter (event) {
            var target = event.target
            var url = target.getAttribute('data-alt-image')
            if (url) {
                this.$emit('changeSwatch', {
                    imageSrc: url,
                    targetUrl: target.getAttribute('href'),
                    onSale: target.getAttribute('data-on-sale')
                })
            }
        },
    },
}
</script>
